export class Solution {
  id: number;
  name: string;
  idExternal: number;
}
